export default __webpack_public_path__ + "static/media/angular-icon.e185415c.svg";